/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlayerSkipForward = createReactComponent("outline", "player-skip-forward", "IconPlayerSkipForward", [["path", { "d": "M4 5v14l12 -7z", "key": "svg-0" }], ["path", { "d": "M20 5l0 14", "key": "svg-1" }]]);

export { IconPlayerSkipForward as default };
//# sourceMappingURL=IconPlayerSkipForward.mjs.map
